import type { BGConfig } from "Data/BGConfig";
import type { LocationID } from "Data/GameConfig";
import * as HLF from "html-living-framework";

function addAsset(
    pID: LocationID,
    assets: HLF.AssetMapData[],
    filename: string | undefined,
    assetType: HLF.AssetType,
) {
    if (filename !== undefined) {
        const assetName = pID + "/" + filename;
        if (assets.find((a) => a.assetName === assetName && a.assetType === assetType)) {
            return;
        }
        if (assetType === HLF.AssetType.JPG) { // all jpegs are @1x
            assets.push(new HLF.TextureAsset(assetName, "images/static/" + assetName + ".jpg"));
        }
        else {
            assets.push(new HLF.AssetMapData(assetName, assetType));
        }
    }
}

export function addBG(
    pID: LocationID,
    assets: HLF.AssetMapData[],
    bg: BGConfig | undefined,
    assetType: HLF.AssetType,
) {
    if (bg !== undefined) {
        if (Array.isArray(bg)) {
            bg.forEach((layer) => addAsset(pID, assets, layer.filename, assetType));
        }
        else {
            addAsset(pID, assets, bg.filename, assetType);
        }
    }
}

function addAudio(
    assets: HLF.AssetMapData[],
    filename: string,
    category: string,
) {
    if (assets.find((a) => a.assetName === filename && a.assetType === HLF.AssetType.AUDIO)) {
        return;
    }
    assets.push(new HLF.AudioAsset(filename, category));
}

export function addVO(
    assets: HLF.AssetMapData[],
    voiceover: string | Array<string|number> | undefined,
) {
    if (voiceover !== undefined) {
        if (Array.isArray(voiceover)) {
            voiceover.forEach((v) => {
                if (typeof(v) === "string") {
                    addAudio(assets, v, HLF.AudioCategory.VO);
                }
            });
        }
        else {
            addAudio(assets, voiceover, HLF.AudioCategory.VO);
        }
    }
}

export function addSFX(
    pID: LocationID,
    assets: HLF.AssetMapData[],
    sfx: string | string[] | undefined,
) {
    if (sfx !== undefined) {
        if (Array.isArray(sfx)) {
            sfx.forEach((s) => {
                addAudio(assets, s, HLF.AudioCategory.SFX);
            });
        }
        else {
            addAudio(assets, sfx, HLF.AudioCategory.SFX);
        }
    }
}

// export function makeSprite(pID: LocationID, pAsset: string): PIXI.Sprite {
//     return HLF.PixiUtils.makeSprite(pID + "/" + pAsset, GameConfig.spritesheets[pID]);
// }
